class Checkout3DBar extends HTMLElement {
  constructor() {
    super();
    this.button = null;
    this.abortController = null;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerEnd = this.onPointerEnd.bind(this);
    this.onPointerLeave = this.onPointerLeave.bind(this);
  }

  connectedCallback() {
    this.button = this.closest('.cart__checkout-button, .quick-add-modal__chrome-button, .harper-product-buy-now');
    if (!this.button || this.abortController) return;

    this.abortController = new AbortController();
    const { signal } = this.abortController;
    this.button.addEventListener('pointermove', this.onPointerMove, { signal });
    this.button.addEventListener('pointerdown', this.onPointerDown, { signal });
    this.button.addEventListener('pointerleave', this.onPointerLeave, { signal });
    window.addEventListener('pointerup', this.onPointerEnd, { signal });
    window.addEventListener('pointercancel', this.onPointerEnd, { signal });
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.abortController = null;
    this.reset();
    this.button = null;
  }

  onPointerMove(event) {
    if (!this.button || event.pointerType !== 'mouse' || this.reducedMotion.matches) return;
    const bounds = this.button.getBoundingClientRect();
    const x = Math.min(1, Math.max(0, (event.clientX - bounds.left) / bounds.width));
    const y = Math.min(1, Math.max(0, (event.clientY - bounds.top) / bounds.height));
    this.button.style.setProperty('--checkout-tilt-x', `${(0.5 - y) * 7}deg`);
    this.button.style.setProperty('--checkout-tilt-y', `${(x - 0.5) * 9}deg`);
    this.button.style.setProperty('--checkout-shine-x', `${x * 100}%`);
    this.button.style.setProperty('--checkout-shine-y', `${y * 100}%`);
  }

  onPointerDown(event) {
    if (!this.button) return;
    this.button.setAttribute('data-pressed', '');

    if (event.pointerType !== 'mouse') {
      const bounds = this.button.getBoundingClientRect();
      const x = Math.min(1, Math.max(0, (event.clientX - bounds.left) / bounds.width));
      const y = Math.min(1, Math.max(0, (event.clientY - bounds.top) / bounds.height));
      this.button.style.setProperty('--checkout-shine-x', `${x * 100}%`);
      this.button.style.setProperty('--checkout-shine-y', `${y * 100}%`);
    }

  }

  onPointerEnd() {
    this.button?.removeAttribute('data-pressed');
    if (this.button && !this.button.matches(':hover')) this.reset();
  }

  onPointerLeave() {
    if (this.button?.hasAttribute('data-pressed')) return;
    this.reset();
  }

  reset() {
    if (!this.button) return;
    this.button.removeAttribute('data-pressed');
    this.button.style.removeProperty('--checkout-tilt-x');
    this.button.style.removeProperty('--checkout-tilt-y');
    this.button.style.removeProperty('--checkout-shine-x');
    this.button.style.removeProperty('--checkout-shine-y');
  }
}

if (!customElements.get('checkout-3d-bar')) {
  customElements.define('checkout-3d-bar', Checkout3DBar);
}
